import { computed, makeObservable } from 'mobx';

import LazyLoadingKeyValueStore, {
  EventBasedTransport,
  addKeyAsIdAndDataSetters,
} from '@codefluegel/lazy-loading-key-value-store';
import { News } from '../types/transport';

export interface NewsKeyVal {
  [key: string]: UpdatableNews;
}

export interface UpdatableNews extends News {
  setTitle: (title: string) => Promise<void>;
  setImageFileName: (fileName: string) => Promise<void>;
  setUrl: (url: string) => Promise<void>;
}

export type NewsWithRoleName = UpdatableNews & {
  roleName: string;
};

export enum Role {
  Architect = 'architect',
  Entrepreneur = 'entrepreneur',
  Handyman = 'handyman',
  TradingPartner = 'tradingPartner',
}

export default class NewsStore extends LazyLoadingKeyValueStore<
  News,
  NewsWithRoleName
> {
  constructor(transport: EventBasedTransport<News>) {
    super(
      transport,
      addKeyAsIdAndDataSetters('roleName', 'title', 'imageFileName', 'url'),
    );
    makeObservable(this, {
      rolesArray: computed,
    });
  }

  get rolesArray(): NewsWithRoleName[] {
    return this.entriesArray;
  }

  updateNews(role: Role, value: News): Promise<void> {
    return this.transport.setEntry(role, value);
  }

  updateNewsProp<T extends keyof News>(
    roleName: Role,
    entryName: T,
    value: News[T],
  ): Promise<void> {
    return this.transport.setEntryProp(roleName, entryName, value);
  }
}
